/* 
 	* 指令下发组件 
 	* 描述: GT420 设置工作模式
 	* 创建时间：2020-10-10
 	* 创建人：wangzy
*/
<template>
	<div>
		<form class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-2 control-label"><span class="red pr5px">*</span>工作模式</label>
			    <div class="col-sm-9" style="display: flex; padding: 4px 0;">
			    	<select v-model="workPattern" @change="workTypeChange" style="border: 1px solid #ccc">
							<option value="interval" label="间隔模式" />
							<option value="reset" label="出厂模式" />
						</select>
						<div class="" v-if="workPattern === 'interval'" style="display: flex; margin-left: 3%;">
							<input type="tel" style="border: 1px solid #ccc" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" onkeyup="value=value.replace(/[^\d]/g,'')" oninput='this.value=this.value.replace(/^[0]+[0-9]*$/gi,"")' v-model="timeInput" :placeholder="showText" :maxlength="inputMaxLength" />
							<select v-model="timeSelect" @change="timeChange" style="margin-left: 3%;border: 1px solid #ccc;">
								<option value="minute" label="分钟" />
								<option value="hour" label="小时" />
								<option value="day" label="天" />
							</select>
						</div>
			    </div> 
			</div>
			<div class="form-group">
				<label class="col-sm-4 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
			<div class="form-group text-right pt10px pr10px">
				<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
				<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
			</div>
		</form>
   </div>	
</template>
<script>
	export default {
	  name: 'InsGT420setWorkMode',
	  data () {
	    return {
	      workPattern: 'interval', // 工作模式下拉选框 1.间隔模式 2.出厂模式
				timeInput: '', // 时间输入框
				showText: '1~43200', // 时间输入框placeholder
				inputMaxLength: 5, // 时间输入框 maxLength
				timeSelect: 'minute', // 时间模式下拉选框 1.分钟 2.小时 3.天
				alertMsg: '',
				timeType: '分钟' // 时间类型 1.分钟 2.小时 3.天
	    }
	  },
	  props: ['from', 'delCmd'],
	  watch: {
	    delCmd (val) {
	      if (val) {
	        this.resetInput()
	      }
	    }
		},
		created () {
			this.timeType = '分钟'
		},
	  methods: {
	    resetInput () {
	      this.workPattern = 'interval'
				this.timeInput = ''
				this.showText = '1~43200'
				this.inputMaxLength = 5
				this.timeSelect = 'minute'
	      this.alertMsg = ''
	    },
	    withdrawBtn () {
	      this.resetInput()
	      if (this.from == 'monitor') {
	        this.$store.dispatch('instModalHide')
	      } else {
	        this.$emit('withdrawBtn')
	      }
			},
			workTypeChange () {
				this.alertMsg = ''
				this.timeInput = ''
				switch (this.workPattern) {
					case 'interval':
						this.timeSelect = 'minute'
						this.showText = '1~43200'
						this.inputMaxLength = 5
						break
					case 'reset':
						this.timeSelect = this.inputMaxLength = this.showText = ''
				}
			},
			timeChange () {
				this.alertMsg = ''
				this.timeInput = ''
				switch (this.timeSelect) {
					case 'minute':
						this.showText = '1~43200'
						this.inputMaxLength = 5
						this.timeType = '分钟'
						break
					case 'hour':
						this.showText = '1~720'
						this.inputMaxLength = 3
						this.timeType = '小时'
						break
					case 'day':
						this.showText = '1~30'
						this.inputMaxLength = 2
						this.timeType = '天'
						break
				}
			},
	    nextClick () {
	      const that = this
	      if (this.timeInput === '' && this.workPattern === 'interval') {
	        this.alertMsg = '请指定间隔时间'
	        return
	      } else {
	        this.alertMsg = ''
				}
				let arr = [] 
				let newTimeInput
				if (this.workPattern === 'interval') {
					if (this.timeSelect === 'minute') {
						if (this.timeInput > 43200 || this.timeInput <= 0) {
							this.alertMsg = '请输入1~43200之间的数字'
							return
						} else {
							newTimeInput = this.timeInput
						}
					} else if (this.timeSelect === 'hour') {
						if (this.timeInput > 720 || this.timeInput <= 0) {
							this.alertMsg = '请输入1~720之间的数字'
							return
						} else {
							newTimeInput = this.timeInput * 60
						}
					} else if (this.timeSelect === 'day') {
						if (this.timeInput > 30 || this.timeInput <= 0) {
							this.alertMsg = '请输入1~30之间的数字'
							return
						} else {
							newTimeInput = this.timeInput * 24 * 60
						}
					}
					arr = ['SETPRM', 'MODE', 1, newTimeInput]
					// cmdString = `工作模式：间隔模式；时间间隔：${this.timeInput}${this.timeType}`
				} else {
					arr = ['SETPRM', 'MODE', 2]
					// cmdString = `工作模式：出厂模式`
				}
	      if (this.from == 'monitor') {
	        this.$store.dispatch('getCmdInfo', arr)
	      } else {
	        this.$emit('nextClick', arr)
				}
				// this.$store.dispatch('setCmdString', cmdString)
				// 发送指令成功之后 清空输入框中的内容
				this.resetInput()
		  }
	  }
	}
</script>

<style scoped>
.input--small /deep/ .input__inner {
	width: 100%;
}
</style>


// WEBPACK FOOTER //
// InsGT420setWorkMode.vue?02d269e9